import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid";
import react, { useCallback, useEffect, useRef, useState } from "react";
import { AccountStatusConfig } from "./AccountStatusConfig";
import Switch from "react-switch";
import { Autocomplete, Modal, Pagination, TextField, Tooltip } from "@mui/material";
import { GenericTable } from "../../components/genericTable/GenericTable";
import { activateInactiveUser, getEntityWithAndFilter } from "../../services/userService";
import { update } from "lodash";
import "./AccountStatus.css";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import UserModal from "../../components/userModal/UserModal";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { login } from "../../services/authenticationService";
import { ArrowWaveLeftDown } from "tabler-icons-react";
import { SearchCategory } from "semantic-ui-react";
import GenricMultiSelect from "../../components/Input/GenericMultiSelect";
import { ChannelkartNetworkGet } from "../../services/networkService";
import * as Sentry from '@sentry/react';
import DefaultHeading from "../../components/heading/DefaultHeading";


const AccountStatus = () => {
    const [users,setUsers] = useState<any[]>([]);
    const [curPage,setCurPage] = useState<number>(1);
    const [totalPage,setTotalPage] = useState<number>(0);
    const [showActivatedPopup,setShowActivatedPopup]=useState<boolean>(false);
	const [popUpMessage, setPopUpMessage] = useState<string>("");
	const [confirmPopupState, setConfirmPopupState] = useState(false)
	const popUpSuccessMethod = useRef<() => void>();
    const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
    const [searchedValue,setSearchedValue]= useState<string>("");
    const [selectedRole,setSelectedRole]=useState<string>("");
    const [allDesignations,setAllDesignations]=useState<string[]>([]);

    useEffect(() => {
        const getRoleDivisionData = async () => {
          try {
            const response = await ChannelkartNetworkGet(
              '/v1/divisions?sort=level:asc&size=100&source=portal&callType=scheduled'
            );
            const features = response.data.features;
    
            const tempDesignations: string[] = [];
            features.forEach((feature: any) => {
              if(feature.divisionName){
                tempDesignations.push(feature.divisionName);
              }
            });
            setAllDesignations(tempDesignations);
          } catch (err) {
            // Sentry.captureException(err);
          }
        };
        getRoleDivisionData();
      }, []);

    const updateConfirmationPopData = (
		message: string,
		methodHelper: () => void
	) => {
		popUpSuccessMethod.current = methodHelper;
		setPopUpMessage(message);
		setConfirmPopupState(true);
	};

    const debouncingTheSearch = useCallback(
        (value: string,role:string) => {
          // debouncing code
          if (timerId) {
            clearTimeout(timerId);
          }
          const newTimerId = setTimeout(() => {
            setCurPage(1);
            getAndSetUsers(value,role);
          }, 400); // debounce time in milliseconds
          setTimerId(newTimerId);
        },
        [getAndSetUsers,searchedValue, timerId]
      );

    async function getAndSetUsers(searchParam?: string,searchRole?:string){
        let response;
        let searchEnabledColumns=["activeStatusReason","activeStatus"];
        let searchedValue=["inactivity_days_exceeded","inactive"];
        if(searchRole){
            searchEnabledColumns.push("designation");
            searchedValue.push(searchRole);
        }
        if(!searchParam){
             response = (await getEntityWithAndFilter("users",curPage-1,searchedValue,searchEnabledColumns));
        }else{
            response = (await getEntityWithAndFilter("users",curPage-1,searchedValue,searchEnabledColumns,searchParam));
        }  
        const tempUsers = response?.data?.features
        const totalPages = response?.data?.totalPage;
        setUsers(tempUsers);
        setTotalPage(totalPages);
    }
    useEffect(()=>{
        getAndSetUsers(searchedValue,selectedRole);
    },[curPage]);
    const columns: GridColDef[] = AccountStatusConfig.columns.map(
        (columnsMetaData) => {
          return {
            disableColumnMenu: true,
            field: columnsMetaData.mappedValue,
            headerName: columnsMetaData.headerName,
            valueGetter: (params: GridRenderCellParams) => {
                const field = params.field;
                const value = params.row[field]
                if(Array.isArray(value)){
                    return value?.[0] ?? "";
                }
                
                return value;
              },
            sortable: false,
            minWidth: 100,
            flex: 1,
            headerAlign: "left",
            align: "left",
            renderHeader: (params: GridColumnHeaderParams) => (
              <Tooltip title={columnsMetaData.headerName}>
                <b>{columnsMetaData.headerName}</b>
              </Tooltip>
            ),
          };
        }
      );
      const addActionAttributes = (
        field: string,
        headerName: string,
        action: (params: GridRenderCellParams) => JSX.Element
      ) => {
        columns.push({
          field,
          headerName,
          sortable: false,
          minWidth: 90,
          flex: 0.5,
          headerAlign: "left",
          align: "left",
          disableColumnMenu: true,
          renderCell: action,
        });
      };
      AccountStatusConfig.Actions.forEach((actionName: string) => {
        switch (actionName) {
          case "Status":
            addActionAttributes(
              "Status",
              "Status",
              (params: GridRenderCellParams) => {
                return (
                  <Switch
                  onChange={async () => {

                    updateConfirmationPopData(
                        "Are you sure want to activate the user?",
                        async () => {
                            await activateInactiveUser(params.row.loginId);
                            getAndSetUsers(searchedValue,selectedRole);
                        }
                    )

                  }}
                  checked={params.row.activeStatus === "active" ? true : false}
                  offColor="#808080"
                  onColor="#24c6b1"
                  size={22}
                  handleDiameter={19}
                  uncheckedIcon={
                    <>
                      <div className="unchecked-icon-status">INACTIVE</div>
                    </>
                  }
                  checkedIcon={
                    <>
                      <div className="checked-icon-status">ACTIVE</div>
                    </>
                  }
                  height={23}
                  width={65}
                />
                );
              }
            );
        }
      });

    

      return<>
        <div className="account_header_container">
          <div className="account_heading_container">
          <DefaultHeading heading="Deactivated Accounts"/>
          </div>
             <div className='account_search_field'>
                    <TextField
                        id="outlined-basic"
                        label="Search by User ID"
                        variant="outlined"
                        size="small"
              
                        autoComplete="off"
                        onChange={(e) => {
                            const searchedData = e.target.value.toString().toLowerCase();
                            setSearchedValue(searchedData);
                            debouncingTheSearch(searchedData,selectedRole);
                
                        }}
                    />
                    <Autocomplete
                    className="autocomplete_active_status"
                    disablePortal
                    size="small"
                    options={allDesignations}
                    value={selectedRole ?? ""}
                    onChange={(e,v) => {
                        const role=v?v:"";
                        setSelectedRole(role);
                        getAndSetUsers(searchedValue,role);
                    }}
                    renderInput={(params) => <TextField {...params}  label="Select Role" />}
                />
                </div>
        </div>

      <div className="table-style">
            <GenericTable
              searchedProps={[]}
              table={{
                rows:users,
                columns,
                isOfflineSearchEnable: false,
                hideFooter: true,
              }}
            />
          <div className="pagination-account-status">
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              color={"primary"}
              onChange={async (event, value) => {
                setCurPage(value);

              }}
              page={curPage}
            />
          </div>
        </div>
        <ConfirmationPopUp
				message={popUpMessage}
				openConfirmModal={confirmPopupState}
				successMethod={popUpSuccessMethod.current}
				setOpenConfirmModal={setConfirmPopupState}
			/>
      </>
     
}
export default AccountStatus;